import type { FaireProductEntity } from "../../entity_types/product";

export const p_wwgkj3xged: FaireProductEntity = {
  token: "p_wwgkj3xged",
  type: "product",
  name: "Pop It Pal",
  brandToken: "b_a7jx8vpa3g",
  brandName: "Vat19",
  imageUrl:
    "https://cdn.faire.com/fastly/6441a5055bd3944d938fba9dca2311a07dd52f15c4f1a9af32b9fda08f7cde6a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2ef2d1f3228810a2f81e85e0d25cc780708d86b8dfbb94d1f7838b38a1c6d52c.jpeg",
    "https://cdn.faire.com/fastly/91acccfff5b5d6ac15beabb70829292c3d5d5383edcc65bc263833fe374cb274.jpeg",
    "https://cdn.faire.com/fastly/28b5288eefb969085196e35776a82f5fff2cf6839586cf3b83709a30e0f84fd8.jpeg",
    "https://cdn.faire.com/fastly/d1f6711030c94f9e16e64eeec7ec2c95aa43ce6feda71730bcb32e389e1847c9.jpeg",
  ],
  priceDollars: 9.99,
  description:
    "Pimple popping is usually confined to the privacy of your bathroom mirror or with millions of strangers on YouTube. Now this strangely addictive viral trend can be experienced anywhere when you play with Pop It Pal. \n\nPop It Pal’s silicone pad is perforated with small holes (representing zits) filled with a fake yellow pus. Pinch the area around a hole and revel in the disgusting-yet-gratifying squirt of pus that comes out. The all-natural, Vaseline-like pus wipes away easily so you can keep on poppin’.\n\nWith 16 poppable pimples per pad and an included refill bottle, you’ll squeeze every ounce of satisfaction out of this oddly entertaining toy.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:41.479Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
